import { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import { FaAngleDown, FaAngleUp, FaCheck } from "react-icons/fa";
import { MdInfoOutline } from "react-icons/md";

import { Text } from "components/common";
import useOnClickOutside, { useScreenSize } from "hooks";
import classes from "./Models.module.css";
import Tabs from "../Tabs/Tabs";
import Header from "./Header/Header";

const Models = ({
  isActive,
  models,
  selectedModel,
  onSelect,
  setIsActive,
  transparent,
  activeModelType,
  setActiveModelType,
  modelTypes,
  userData,
}) => {
  const ref = useRef(null);
  const dropdownRef = useRef(null);

  const filteredModels = models.filter(
    (model) => model.model_type === activeModelType
  );
  const onClose = () => {
    setIsActive(false);
  };
  const isSmallScreen = useScreenSize(767);
  // Close dropdown when clicking outside
  useOnClickOutside(ref, () => {
    if (!isSmallScreen) {
      setIsActive(false);
    }
  });

  const handleModelSelect = (model) => {
    if (model.tags?.includes("Pro") && !userData?.is_pro) {
      // If it's a Pro model and user is not Pro, don't allow selection
      return;
    }
    setIsActive(false);
    onSelect(model);
  };

  const getColorClass = (index) => {
    const colors = ['color1', 'color2', 'color3', 'color4', 'color5'];
    return colors[index % colors.length];
  };

  return (
    <>
      <div className={clsx(classes.dropdown)} ref={ref}>
        <div
          className={clsx(
            classes.labelContainer,
            transparent && classes.transparent
          )}
          onClick={() => setIsActive((prev) => !prev)}
        >
          <Text primitiveDefault className={classes.name}>
            {selectedModel?.name}
          </Text>

          <div className={classes.tags}>
            {selectedModel?.tags?.map((tag, i) => (
              <Text
                xs
                medium
                className={clsx(
                  classes.tag,
                  tag === "Beta" && classes.beta,
                  tag === "Pro" && classes.pro,
                  tag === "HA" && classes.pro,
                  tag === "Rogue" && classes.rogue
                )}
                key={i}
              >
                {tag === "Rogue" ? `Uncensored` : 
                 tag === "HA" ? `HA` : 
                 tag === "Pro" ? `${tag}` :
                 tag}
              </Text>
            ))}
          </div>
          {isActive ? (
            <FaAngleUp className={classes.arrow} />
          ) : (
            <FaAngleDown className={classes.arrow} />
          )}
        </div>

        <div
          ref={dropdownRef}
          className={clsx(classes.dropdownMain, isActive && classes.active)}
          role="listbox"
          aria-expanded={isActive}
        >
          <Header
            heading="AI Model"
            onClose={onClose}
            className={classes.topHeader}
          />
          <div className={classes.header}>
            <Tabs
              activeTab={activeModelType}
              setActiveTab={setActiveModelType}
              tabs={modelTypes}
            />
            <button className={classes.infoButton}>
              <MdInfoOutline />
            </button>
          </div>
          <div className={clsx(classes.list, "overflow")}>
            {filteredModels.length > 0 ? (
              filteredModels?.map((model, idx) => {
                const isProModel = model.tags?.includes("Pro");
                const isDisabled = isProModel && !userData?.is_pro;
                return (
                  <div
                    key={`item-${idx}`}
                    className={clsx(
                      classes.listItem,
                      selectedModel?.id === model?.id && classes.active,
                      isDisabled && classes.disabled,
                      classes[getColorClass(idx)]
                    )}
                    onClick={() => handleModelSelect(model)}
                  >
                    <div>
                      <div className={classes.nameContainer}>
                        <Text sm primitive50 medium>
                          {model?.name}
                        </Text>
                        <div className={classes.tags}>
                          {model?.tags?.map((tag, i) => (
                            <Text
                              xs
                              medium
                              className={clsx(
                                classes.tag,
                                tag === "Beta" && classes.beta,
                                tag === "Pro" && classes.pro,
                                tag === "HA" && classes.pro,
                                tag === "Rogue" && classes.rogue
                              )}
                              key={i}
                            >
                              {tag === "Rogue" ? `Uncensored` : 
                               tag === "HA" ? `HA` : 
                               tag === "Pro" ? `${tag}` :
                               tag}
                            </Text>
                          ))}
                        </div>
                      </div>
                      <Text xs primitive300>
                        • BETA
                      </Text>
                    </div>
                    {selectedModel.id === model.id && (
                      <FaCheck className={classes.checkIcon} />
                    )}
                  </div>
                );
              })
            ) : (
              <Text primitive50 textCenter sm>
                {" "}
                None Available
              </Text>
            )}
          </div>
        </div>
      </div>
      {isActive && (
        <div
          className={clsx(isActive && classes.active, classes.modalOverlay)}
        />
      )}
    </>
  );
};

export default Models;
